import React, { Component } from 'react';
import { Link } from "react-router-dom";

import { Button } from 'antd';
import { Layout } from 'antd';
import { Menu } from 'antd'
import { Row, Col } from 'antd';
import { Anchor } from 'antd'
import { Carousel } from 'antd';

import './Main.less';
import './Content.less'

const { Header, Footer, Sider, Content } = Layout;

class Main_2018 extends Component {
    componentDidMount() {
        document.title = 'Summer School 2018';
    }


    render() {
        return (
            <Layout>
                <Header id='header' style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
                    <Row type='flex'>
                        <Col>
                            <Link to='/'>
                                <img
                                    alt="logo"
                                    src="logo-nmbu.png"
                                    style={{ maxHeight: '50px' }}
                                />
                            </Link>
                        </Col>
                        <Col style={{ marginLeft: 'auto' }}>
                            <Menu
                                id='nav'
                                theme="light"
                                mode="horizontal"
                            >
                                <Menu.Item key="0">
                                    <Link to='/2019' style={{ fontWeight: 700 }}>2019</Link>
                                </Menu.Item>
                                <Menu.Item key="1">
                                    <a href="#about">About</a>
                                </Menu.Item>
                                <Menu.Item key="2">
                                    <a href='#materials'>Materials</a>
                                </Menu.Item>
                                <Menu.Item key="3">
                                    <a href='#program'>Program</a>
                                </Menu.Item>
                                <Menu.Item key="4">
                                    <a href='#photo'>Photos</a>
                                </Menu.Item>
                                <Menu.Item key="5">
                                    <a href='#venue'>Venue</a>
                                </Menu.Item>
                                <Menu.Item key="6">
                                    <a href='#contact'>Contact</a>
                                </Menu.Item>
                            </Menu>
                        </Col>
                    </Row>
                </Header>
                <Content style={{ marginTop: 64, backgroundColor: 'white' }}>
                    <section id='hero-area' className='main-container'>
                        <Row gutter={64}>
                            <Col sm={12} xs={24}>
                                <h1>Interdisciplinary summer school<br />on mining of biological data</h1>
                                <p>August 11th – 19th 2018, Ås, Norway</p>
                            </Col>
                            <Col sm={12} xs={24}>
                                {/* <iframe title='Summer School Video' width="560" height="315" src="https://www.youtube.com/embed/qE8KGDy0Tx8" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
                                <iframe style={{ maxWidth: "100%" }} title='Summer School Video' width="560" height="315" src="https://www.youtube.com/embed/qE8KGDy0Tx8" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Col>
                        </Row>
                    </section>
                    <section id='about' className='main-container'>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Summer School Scope & Goals
                            </h2>
                            </div>
                            <div>
                                <p>
                                    Norwegian University of Life Sciences, together with Belarusian State University and United Institute of Informatics Problems (National Academy of Sciences of Belarus), is organizing a summer school for Master and PhD students dedicated to analysis of biological data in infrared spectroscopy. Attendees will be introduced to the basics in molecular biology, machine learning and physics of infrared absorption, explained by renowned scientists in the corresponding fields. The main aim of summer school is to provide experience in solving a complex research problem in a multidisciplinary team. Students in biology, physics and computer science will work together on a two-day project culminating in a project defense and a presentation session for early-stage researchers to share their research findings with other participants.
                                </p>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Acknowledgement
                            </h2>
                            </div>
                            <div>
                                <p>
                                    This summer school has been supported by the SIU project <i>"Belanoda - Multidisciplinary graduate and post-graduate education in big data analysis for life sciences"</i> (project number CPEA-LT-2016/10126) funded by the Eurasia program, Norwegian Center for International Cooperation in education (SIU).
                                </p>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Participation prerequisites
                            </h2>
                            </div>
                            <div>
                                <p>
                                    Certain topics from molecular biology, machine learning and spectroscopy will be covered extensively during summer school. However, participants are expected to have a background in mathematics equivalent to a first-year university course and an intermediate-level English sufficient to participate and be successful in learning process. Solid reasoning, ability to grasp quickly interdisciplinary relations and experience with group work is highly appreciated.
                                </p>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    What will you get?
                            </h2>
                            </div>
                            <div>
                                <ul>
                                    <li>
                                        Learn basics from unfamiliar fields (biology, physics, data science)
                                    </li>
                                    <li>
                                        Learn how to combine it all to analyse spectra of organic compounds
                                    </li>
                                    <li>
                                        Experience of working in an interdisciplinary and international group
                                    </li>
                                </ul>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Dates
                            </h2>
                            </div>
                            <div>
                                <p>August 11th – 19th 2018: Summer School</p>
                            </div>
                        </Row>
                    </section>


                    <section id='materials' className='main-container'>
                        <div className='heading'>
                            <h2>Materials</h2>
                        </div>
                        <Row>
                            <p>Videos (including pre-course lectures) are available online:</p>
                            <Row type="flex" justify="center">
                                <Col>
                                    <Button ghost href="https://www.youtube.com/watch?v=qE8KGDy0Tx8&list=PLsvFOj1U2b6r2X0hpzaNCVao3Wt8D0uQc" target="_blank">Videos</Button>
                                </Col>
                                {/* <Col>
                                    <Button ghost href="https://nmbu.instructure.com/courses/3490/files" target="_blank">Materials</Button>
                                </Col> */}
                            </Row>
                        </Row>
                    </section>


                    <section id="program" className='main-container'>
                        <div className='heading'>
                            <h2>Program</h2>
                        </div>
                        <img alt="program"
                            src="ProgramSIUsommerSchool2018_cropped.png"
                            style={{ maxWidth: '100%' }}></img>
                        <p>Pdf version of the program can be found <a href="ProgramSIUsommerSchool2018.pdf" rel="noopener noreferrer" target='_blank'>here</a></p>
                    </section>


                    <section id="photo" className="main-container">
                        <div className='heading'>
                            <h2>Photos</h2>
                        </div>
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                            <Carousel autoplay>
                                <img src="2019-02-10 17.05.02.jpg" alt="" />
                                <img src="2019-02-10 17.05.11.jpg" alt="" />
                                <img src="2019-02-10 17.05.15.jpg" alt="" />
                                <img src="2019-02-10 17.05.23.jpg" alt="" />
                                <img src="2019-02-10 18.15.33.jpg" alt="" />
                                <img src="2019-02-10 18.40.11.png" alt="" />
                                <img src="2019-02-10 18.39.42.png" alt="" />
                                <img src="2019-02-10 18.19.23.jpg" alt="" />
                            </Carousel>
                        </div>
                    </section>


                    <section id="venue" className="main-container">
                        <div className='heading'>
                            <h2>Venue</h2>
                        </div>
                        <p>The school will be held at <a href='https://goo.gl/maps/txiHV5KBYak' rel="noopener noreferrer" target='_blank'>NMBU clock building</a>.</p>
                        <img src='nmbu_clock_building_map.png' alt='Map' style={{ maxWidth: '100%' }}></img>
                        <p>Pdf of campus map you may find <a href="https://www.nmbu.no/sites/default/files/pdfattachments/nmbu_campus_as_kart16_23-6-16.pdf" rel="noopener noreferrer" target='_blank'>here</a></p>
                    </section>


                    <section id='contact' className='main-container'>
                        <div className="heading">
                            <h2>Contact</h2>
                        </div>
                        <Row>
                            <p>If you have any further questions about our summer school, feel free to send us an email to <a href='mailto:nmbu@nmbu.no'>nmbu@nmbu.no</a>.</p>
                        </Row>
                    </section>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    BioSpec Group ©2019 Created by BioSpec
                </Footer>
            </Layout>
        );
    }
}

export default Main_2018;
